/**
 * Monument Constructor - Main Entry Point
 *
 * This is the refactored version of monument-constructor-konva.js
 * Split into modular components for better maintainability
 */
import { MC_FONTS } from "./constants.js";
import { appState } from "./state.js";
import { initFontSelect, preloadFonts } from "./utils.js";
import { StageManager } from "./stage.js";
import { TextManager } from "./text-manager.js";
import { PhotoEditor } from "./photo-editor.js";
import { DecorManager } from "./decor-manager.js";
import { MonumentManager } from "./monument-manager.js";
import { EventHandlers } from "./event-handlers.js";
import { ConstructorPreloader } from "./preloader.js";

jQuery(function ($) {
	// Check if wrapper exists
	const $wrapper = $(".mc-wrapper");
	if (!$wrapper.length) return;

	const $stageContainer = $("#mc-stage-container");
	if (!$stageContainer.length) return;

	const preloader = new ConstructorPreloader(".mc-wrapper");
	preloader.show();

	// Initialize managers
	const stageManager = new StageManager($stageContainer);
	const textManager = new TextManager(stageManager, appState);
	const photoEditor = new PhotoEditor(stageManager, appState);
	const decorManager = new DecorManager(stageManager, appState);
	const monumentManager = new MonumentManager(stageManager, appState);
	const eventHandlers = new EventHandlers(
		stageManager,
		textManager,
		photoEditor,
		decorManager,
		monumentManager,
		appState,
	);

	// Initialize fonts
	initFontSelect(MC_FONTS);
	const fontsReady = preloadFonts(MC_FONTS);

	// Set initial product ID
	appState.currentProductId =
		parseInt($wrapper.data("selected-product"), 10) ||
		window.MC_DATA.default_product_id;

	// Render monuments list and load initial monument
	monumentManager.renderProductsList();
	monumentManager.renderCandlesList();
	const monumentReady = monumentManager.loadMonumentImage(
		appState.currentProductId,
	);
	monumentManager.highlightSelectedProduct(appState.currentProductId);

	// Add default texts
	textManager.addDefaultTexts();

	// Ensure fonts re-render once webfonts finish loading
	fontsReady.then(() => {
		textManager.refreshAllTextFonts();
	});

	// Load initial decors
	const decorsReady = $(".mc-decor-list").length
		? decorManager.loadDecors("")
		: Promise.resolve();

	// Initialize all event handlers
	eventHandlers.init();

	// Expose setActiveElement method for photo editor and decorManager
	window.mcSetActiveElement = (node, options = {}) => {
		eventHandlers.setActiveElement(node, options);
	};

	// Expose setActiveTextElement method for text manager
	window.mcSetActiveTextElement = (node, options = {}) => {
		eventHandlers.setActiveTextElement(node, options);
	};

	Promise.all([fontsReady, monumentReady, decorsReady])
		.catch((err) => {
			console.warn("Preloader wait list failed", err);
		})
		.finally(() => {
			preloader.hide();
		});
});
